import { Box, Heading, Link, Paragraph } from '@/src/packages/components';
import { PageSectionStack } from '@/src/packages/components/templates/PageSectionStack';
import { IMaker } from '@/src/interfaces/generated/contentful';
import { TemplateSidebar } from '@/src/packages/components/templates/TemplateSidebar';
import { ManufacturingLinks } from '@/src/packages/components/ui/Footer/Footer.config';
import Image from 'next/image';
import { Text } from '@/src/packages/components/ui/Text';
import NextLink from 'next/link';
import { getRoute } from '@/src/packages/utils/routes';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';

type IMakersProps = {
  makers: IMaker[];
};

export const MakerCard = ({ item }: { item: IMaker }) => {
  return (
    <Box className="bg-background-secondary grid grid-cols-12">
      <Box className="col-span-12 space-y-8 px-8 py-6 lg:col-span-6">
        <Box className="space-y-2">
          <Heading
            as="h3"
            size="h2"
            className="font-serif text-2xl leading-none"
          >
            {item.fields.name}
          </Heading>
          <Text className="text-text-secondary leading-none">
            {item.fields.country?.fields.name}
          </Text>
        </Box>
        <Link variant="solid" className="inline-block" asChild>
          <NextLink
            href={getRoute({
              route: paths.MAKERS_SINGLE,
              params: {
                [pathParams.MAKER_SINGLE]: item.fields.slug,
              },
            })}
          >
            Learn more
          </NextLink>
        </Link>
      </Box>

      <Box className="relative col-span-12 aspect-video lg:col-span-6 lg:aspect-square">
        <Image
          alt={`${item.fields.name} cover image`}
          src={item.fields.cover.fields.file.url}
          fill
          className="object-cover"
          sizes="(max-width: 1024px) 100vw, 50vw"
        />
      </Box>
    </Box>
  );
};

export const Makers = (props: IMakersProps) => {
  const { makers } = props;

  return (
    <TemplateSidebar title="Makers" links={ManufacturingLinks}>
      <PageSectionStack>
        <Paragraph className="max-w-2xl" size="lead">
          Crafting a timeless piece demands three essential elements: timeless
          aesthetics, quality materials, and unparalleled craftsmanship. We go
          to great lengths to ensure we meet the standards we have set for
          ourselves, starting with our materials and manufacturing partners.
        </Paragraph>

        <Box className="gap-gutter grid grid-cols-12">
          {makers.map((item, i) => {
            return (
              <Box className="col-span-12" key={i}>
                <MakerCard item={item} />
              </Box>
            );
          })}
        </Box>
      </PageSectionStack>
    </TemplateSidebar>
  );
};
